var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-2 text-red-700 bg-red-100 rounded-full",attrs:{"title":"Exception Event"}},[_c('Icon',{class:_vm.dropdown ? 'w-4 h-4' : 'w-6 h-6',attrs:{"icon":"solar:danger-circle-broken"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }